// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4042652","453":"4fd96eb9","667":"bff4b24d"}[chunkId] + ".chunk.js";
};